<template>
  <div class="wrapper">
    <router-view />
  </div>

  <div class="modal-target"></div>
</template>

<script setup lang="ts">
  import { captureException, reportMFRendered } from '@experience/core-hostapp-share-lib';
  import { initHotReloader } from '@experience/vite-plugin-wc-extract-styles';
  import { onErrorCaptured, onMounted, useShadowRoot, nextTick } from 'vue';
  import { useRouter } from 'vue-router';
  import './assets/reset.scss';
  import { useHelpCenterClient } from '@/shared/api/useHelpCenterApiClient';

  const router = useRouter();
  const MF_NAME = 'help-center-mfe';

  onErrorCaptured((err) => captureException(err, { mf: MF_NAME }));
  useHelpCenterClient();
  onMounted(async () => {
    await router.isReady();
    await nextTick();
    setTimeout(() => {
      reportMFRendered(MF_NAME);
    }, 0);
  });

  const shadowRoot = useShadowRoot();

  provide('shadowRoot', shadowRoot);

  initHotReloader(import.meta.hot, shadowRoot);
</script>

<style lang="scss"></style>
